<template>
    <header class="header-wrapper position-relative">
        <div class="container pt-20 pb-20">
            <div class="row d-flex align-center justify-between position-relative">
                <div class="header-left d-flex align-center gap-20">
                    <router-link to="/" class="logo">
                        <img :src="require('@/assets/images/logo.svg')" alt="Logo">
                    </router-link>

                    <nav-bar />
                </div>

                <div class="header-right d-flex align-center gap-20">
                    <search-box />

                    <ul class="social-links d-flex align-center gap-20">
                        <li>
                            <a href="#" class="d-block"><font-awesome-icon :icon="['fab', 'fa-facebook-f']" /></a>
                        </li>
                        <li>
                            <a href="#" class="d-block"><font-awesome-icon :icon="['fab', 'fa-linkedin-in']" /></a>
                        </li>
                        <li>
                            <a href="#" class="d-block"><font-awesome-icon :icon="['fab', 'fa-twitter']" /></a>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </header>
</template>

<script>
import NavBar from './NavBar.vue';
import SearchBox from '../Modules/SearchBox.vue';


export default {
    name: 'ThemeHeader',
    components: {
        NavBar,
        SearchBox
    }
}
</script>